/**
 * One-time hint on first advice card view — dismissible, stored server-side per user.
 */
import React, { useEffect, useState } from 'react';
import { XMarkIcon, BookmarkIcon } from '@heroicons/react/24/outline';
import axios from 'axios';

const SaveDiscoverabilityHint = ({ user, visible }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || !visible) {
      setShow(false);
      return;
    }
    axios
      .get('/api/engagement/hints/save-advice')
      .then((res) => setShow(res.data?.show_hint === true))
      .catch(() => setShow(false));
  }, [user, visible]);

  const dismiss = async () => {
    setShow(false);
    try {
      await axios.post('/api/engagement/hints/save-advice/dismiss');
    } catch (e) {
      console.error(e);
    }
  };

  if (!show) return null;

  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-hairline bg-pine-tint px-3 py-2.5">
      <BookmarkIcon className="w-5 h-5 text-pine shrink-0 mt-0.5" />
      <p className="text-label text-secondary leading-snug flex-1">
        Like this? <span className="font-semibold text-pine">Save</span> it and set your own{' '}
        <span className="font-semibold text-pine">reminder</span> — you choose when, not Aura.
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="p-1 text-faint hover:text-primary rounded"
        aria-label="Dismiss hint"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
};

export default SaveDiscoverabilityHint;
